<div style="background-color: #303845; height: 130px;">
    <div class="grid justify-content-center align-items-start align-content-start">
        <div class="col-12 md:col-6 lg:col-4" style="text-align: center; vertical-align: middle;">
            <div class="col-12 mt-4" style="text-align: center;vertical-align: middle;">
                <p-image [routerLink]="['/inicios/ventanilla-unica-construccion']"
                         src="assets/demo/images/logos/dot_logo.png" alt="Image" height="50"
                         [ngStyle]="{'filter': 'invert(1) brightness(2)'}"></p-image>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <div class="text-center p-3 border-round-sm font-bold">
                <div class="row overflow-hidden">
                    <div class="col-12" style="text-align: center;">

                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <div class="text-center p-3 border-round-sm font-bold">

            </div>
        </div>
    </div>
</div>
